import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export default function QuickRegisterAndFAQ() {
  const { t } = useTranslation('faqs')
  const [openIndex, setOpenIndex] = React.useState<number | null>(null)

  const faqs = [
    {
      question: t('track_package_q'),
      answer: t('track_package_a'),
    },
    {
      question: t('late_package_q'),
      answer: t('late_package_a'),
    },
    {
      question: t('absent_recipient_q'),
      answer: t('absent_recipient_a'),
    },
  ]

  return (
    <div className="container mx-auto my-16 bg-white flex flex-col gap-12">
      {/* 注册引导 / Section d'inscription */}
      <div className="flex flex-col md:flex-row items-center justify-between gap-8 rounded-3xl border-2 border-primary shadow-lg p-8 md:p-12 ">
        <div className="md:w-1/2 w-full">
          <div className="text-2xl md:text-3xl font-bold mb-2">
            <span className="text-primary">{t('register_title')}</span>
            <span className="text-[#b3b36c]">?</span>
          </div>
          <div className="text-xl md:text-2xl font-bold mb-4">
            <span className="text-black">{t('register_subtitle')}</span>
          </div>
          <div className="text-gray-700 mb-6">{t('register_desc')}</div>
          <Link
            className="bg-[#ffc43a] text-white px-6 py-2 rounded font-bold shadow hover:bg-[#ffb300] transition"
            to="/auth/signup"
          >
            {t('register_button')}
          </Link>
        </div>
        <div className="md:w-1/2 w-full flex justify-center">
          <img
            src="https://fradaexpress.s3.eu-west-1.amazonaws.com/homepage/faq.png"
            alt={t('register_alt')}
            width={300}
            height={180}
            className="object-contain"
          />
        </div>
      </div>
      {/* FAQ区域 / Section FAQ */}
      <div className="flex flex-col md:flex-row items-start gap-8">
        <div className="md:w-1/2 w-full mb-6 md:mb-0">
          <div className="text-2xl font-bold mb-2 text-primary">
            {t('faq_title')}
          </div>
          <div className="text-gray-700 mb-6">{t('faq_desc')}</div>
        </div>
        <div className="md:w-1/2 w-full">
          {faqs.map((faq, idx) => (
            <div key={idx} className="mb-4 border-b last:border-b-0">
              <button
                className="w-full flex justify-between items-center py-4 text-left font-bold text-primary focus:outline-none"
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                aria-expanded={openIndex === idx}
              >
                <span>{faq.question}</span>
                <span
                  className={`transform transition-transform ${
                    openIndex === idx ? 'rotate-90' : ''
                  }`}
                >
                  ▶
                </span>
              </button>
              {openIndex === idx && (
                <div className="text-gray-700 pb-4 pl-2 pr-2 animate-fade-in">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
